module.exports = __webpack_public_path__ + "img/s-crossForm.88ce5f80.svg";